import React from 'react'
import PropTypes from 'prop-types'

export const hasQuestionTitleImage = (imageSrc) => {
  if (!imageSrc) return false
  if (Array.isArray(imageSrc)) return imageSrc.some(Boolean)
  return true
}

const getQuestionTitleImageSources = (imageSrc) => {
  if (!imageSrc) return []
  if (Array.isArray(imageSrc)) return imageSrc.filter(Boolean)
  return [imageSrc]
}

const QuestionTitleImage = ({ imageSrc, questionId, className }) => {
  const sources = getQuestionTitleImageSources(imageSrc)
  if (!sources.length) return null

  return sources.map((src, index) => (
    <img
      key={`${questionId}-${index}`}
      className={className}
      src={src}
      alt={`q-${questionId}${sources.length > 1 ? `-${index}` : ''}`}
    />
  ))
}

QuestionTitleImage.propTypes = {
  imageSrc: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  className: PropTypes.string,
}

export default QuestionTitleImage
